import React from 'react'
import './css/Annonce.css'
import {Link,useHistory} from "react-router-dom";
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
function Favoris() {
    return (
        <div className="body">
            <button>
                <FavoriteBorderOutlinedIcon className="icon"/>
                <p>Mes favoris</p>
            </button>
            
            <form>
                <select name="filtersList" class="s">
                    <option value="FAVORITE_ADS">Annonces sauvegardées </option>
                    <option value="SAVED_SEARCH">Recherches sauvegardées </option>
                </select>
                <ExpandMoreIcon className="icon i2"/>
            </form>
            <div className="tex">
                <img src="https://account.avito.ma/phoenix-assets/imgs/account/noResultFavories.png"/>
                <p>Vous n'avez aucune annonce sauvegardée</p>
                
                <Link to="/deposer" style={{textDecoration:"none"}}>
                    <button>
                        <p><CameraAltOutlinedIcon className="ico"/>Déposer une annonce</p>
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default Favoris
